import Icon from '../components/Icon.vue'

Icon.register({"ghost":{"width":384,"height":512,"paths":[{"d":"M186.1 0.1C81 3.2 0 94.9 0 200.1V464C0 478.2 17.2 485.4 27.3 475.3L52.2 456.8C58.9 451.8 68.2 452.8 73.7 459L116.7 507.3C122.9 513.6 133.1 513.6 139.3 507.3L180 461.5C186.4 454.3 197.6 454.3 204 461.5L244.7 507.3C250.9 513.6 261.1 513.6 267.3 507.3L310.3 459C315.8 452.8 325.1 451.8 331.8 456.8L356.7 475.3C366.8 485.4 384 478.2 384 464V192C384 84 294.8-3.2 186.1 0.1zM128 224C110.3 224 96 209.7 96 192S110.3 160 128 160 160 174.3 160 192 145.7 224 128 224zM256 224C238.3 224 224 209.7 224 192S238.3 160 256 160 288 174.3 288 192 273.7 224 256 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/ghost.js
// module id = null
// module chunks = 